export interface SettingState {
    isGlobalSettingVisible: boolean;
}

export const SHOW_GLOBAL_SETTING = 'SHOW_GLOBAL_SETTING';
export const HIDE_GLOBAL_SETTING = 'HIDE_GLOBAL_SETTING';

export interface ShowGlobalSettingAction {
    type: typeof SHOW_GLOBAL_SETTING;
}

export interface HideGlobalSettingAction {
    type: typeof HIDE_GLOBAL_SETTING;
}

export type SettingActionType = ShowGlobalSettingAction | HideGlobalSettingAction;
